function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import { countriesI18n } from "../base/countries-i18n";
import { CountryType, exceptionallyReservedCountries, transitionallyReservedCountries } from "./countries-i18n-expanded.vm";
const getTransitionallyReservedCountry = (countryCode, lang) => transitionallyReservedCountries[countryCode] ? transitionallyReservedCountries[countryCode][lang] : undefined;
const getExceptionallyReservedCountry = (countryCode, lang) => exceptionallyReservedCountries[countryCode] ? exceptionallyReservedCountries[countryCode][lang] : undefined;
const getOfficiallyAssignedCountry = (countryCode, lang) => countriesI18n.getName(countryCode, lang);
const getAbstractTypeCountriesNames = (countries, lang) => {
  const names = {};
  Object.entries(countries).forEach(([key, value]) => {
    names[key] = value[lang];
  });
  return names;
};
const getTransitionallyReservedNames = lang => getAbstractTypeCountriesNames(transitionallyReservedCountries, lang);
const getExceptionallyReservedNames = lang => getAbstractTypeCountriesNames(exceptionallyReservedCountries, lang);
const getOfficiallyAssignedNames = lang => countriesI18n.getNames(lang);
const getName = (countryCode, lang) => {
  let name = getOfficiallyAssignedCountry(countryCode, lang);
  if (!name) name = getTransitionallyReservedCountry(countryCode, lang);
  if (!name) name = getExceptionallyReservedCountry(countryCode, lang);
  return name;
};
const getNames = lang => {
  const officially = getOfficiallyAssignedNames(lang);
  const transitionally = getTransitionallyReservedNames(lang);
  const exceptionally = getExceptionallyReservedNames(lang);
  return _objectSpread(_objectSpread(_objectSpread({}, transitionally), exceptionally), officially);
};
const getTypeNames = (lang, type) => {
  switch (type) {
    case CountryType.OFFICIALLY_ASSIGNED:
      return getOfficiallyAssignedNames(lang);
    case CountryType.TRANSITIONALLY_RESERVED:
      return getTransitionallyReservedNames(lang);
    case CountryType.EXCEPTIONALLY_RESERVED:
      return getExceptionallyReservedNames(lang);
    default:
      return {};
  }
};
const getCountryType = countryCode => {
  if (countriesI18n.isValid(countryCode)) return CountryType.OFFICIALLY_ASSIGNED;
  if (transitionallyReservedCountries[countryCode]) return CountryType.TRANSITIONALLY_RESERVED;
  if (exceptionallyReservedCountries[countryCode]) return CountryType.EXCEPTIONALLY_RESERVED;
  return undefined;
};
export const countriesI18nExpanded = {
  getName,
  getNames,
  getTypeNames,
  getCountryType
};